export default {"src":"/_next/static/media/carOutlinePatch_40.73dbed08.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};